const Payment = () => {
  return (
    <div className="min-h-screen bg-canvas pb-20 text-ink">
      <section className="relative overflow-hidden border-b border-primary/10 bg-white">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-white to-white" />
        <div className="relative mx-auto flex max-w-5xl flex-col items-center gap-4 px-4 py-12 text-center lg:px-6">
          <h1 className="text-3xl font-semibold sm:text-4xl">Payment</h1>
          <p className="max-w-3xl text-sm leading-relaxed text-ink-muted sm:text-base">
            Secure your seat in upcoming batches. This is a placeholder for the integrated payment
            gateway and enrollment workflows.
          </p>
        </div>
      </section>

      <section className="mx-auto mt-16 w-full max-w-5xl px-4 text-sm leading-relaxed text-ink-muted sm:text-base lg:px-6">
        <h2 className="text-2xl font-semibold text-ink sm:text-3xl">Coming Soon</h2>
        <p className="mt-4">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
          labore et dolore magna aliqua. Pulvinar neque laoreet suspendisse interdum consectetur
          libero id faucibus nisl tincidunt.
        </p>
        <div className="mt-8 flex flex-wrap gap-4">
          {['Visa', 'Mastercard', 'UPI', 'NetBanking'].map((label) => (
            <div
              key={label}
              className="flex flex-1 min-w-[140px] items-center justify-center rounded-xl bg-primary/10 px-4 py-3 text-sm font-semibold text-primary"
            >
              {label}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Payment;

